import { useEffect, useState } from "react";

export default function Countdown({ num = 180, onStatusChange }) {
	const [timeLeft, setTimeLeft] = useState(num);

	useEffect(() => {
		if (timeLeft <= 0) return;

		const timer = setInterval(() => {
			setTimeLeft((prev) => prev - 1);
		}, 1000);

		return () => clearInterval(timer);
	}, [timeLeft]);

	const hours = Math.floor(timeLeft / 3600);
	const minutes = Math.floor((timeLeft % 3600) / 60);
	const seconds = timeLeft % 60;

	const format = (num) => String(num).padStart(2, "0");

	useEffect(() => {
		if (onStatusChange) {
			onStatusChange({
				showHours: hours > 0,
				isFinished: timeLeft <= 0,
				timeLeft,
			});
		}
	}, [hours, timeLeft, onStatusChange]);

	return (
		<span className='text-[15px] sm:text-[20px] text-[rgba(113,59,18,1)] font-medium'>
			{timeLeft >= 3600 && `${format(hours)}:`}
			{format(minutes)}:{format(seconds)}
		</span>
	);
}